// extracted by mini-css-extract-plugin
export var header = "cook-module--header--d0mZO";
export var text = "cook-module--text--hpobY";